// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.explorerContainer {
    .controlbuttons {
        border: none;
        border-radius: 50%;
        height: 30px;
        width: 30px;
        margin-right: 0.3rem;
    }
    .file-viewer{
      overflow-x: hidden;
      max-width: 300px;
      overflow-y: auto;
    }
    .width-full-tree{
      width: 100%;
  min-width: 0;
  max-width: 100%;
  flex: 1 1 auto;
    }
    /* Add this to your main CSS file (e.g., index.css or component-specific CSS) */

.custom-context-menu {
  position: absolute;
  width: 200px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow: hidden;
  font-size: 14px;
  transform-origin: bottom;
}

/* Ensure the menu opens upwards if near the bottom of the viewport */
.custom-context-menu.open-upwards {
  transform: translateY(-100%-100);
}

.folder-path{
  color: #2c3e50;            /* Dark but soft */
  font-weight: 600;          /* Slightly bold */
  background-color: #f4f6f8; /* Light gray background for contrast */
  padding: 4px 8px;
  border-radius: 6px;
  display: inline-block;
  max-width: 100%;
  overflow-x: auto;
  white-space: nowrap;
}

.custom-context-menu button {
  width: 100%;
  padding: 10px 16px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.custom-context-menu button:hover {
  background-color: #f1f1f1;
}

.custom-context-menu .danger {
  color: #e53935;
}

.custom-context-menu .danger:hover {
  background-color: #fdecea;
}

    .card-body-container{
      background-color: white;
    }
    .overflow-text-wrap{
    width: 22vw;
    white-space: nowrap;
    text-overflow: ellipsis;
    }
    .controller-container{
      width: 12vw;
    }

    .editStorageButton {
        background: #f8f7ff;
        color: #16a085;
    }

    .editStorageButton:hover {
        background: #16a085;
        color: white;
    }

    .deleteStorageButton {
        background: #f8f7ff;
        color: #d63031;
    }

    .deleteStorageButton:hover {
        background: #d63031;
        color: white;
    }

    .menubuttons {
        width: 100%;
        border: none;
        text-align: left;
    }

    .menubuttons:hover {
        background-color: rgb(230, 230, 230);
    }

    .ContainerForExplorer {
        .MuiBackdrop-root {
            background: none;
        }

        .MuiBox-root {
            width: 50%;
        }

    }
}

.containerForModalSelector {
    display: flex;
    justify-content: space-between;

    .toastCloser {
        margin-top: -6%;
        background: transparent;
        border: none;
    }
}

.add-storage-modal-container{
    .mandatory-fields{
        color: red;
    }
}
.alert-container{
    margin-top: 0.5%;
  position: absolute;

  .alertImg {
    margin-left: 3%;
  }

  #toast {
    visibility: hidden;
    border: 1px solid;
    border-left: 10px solid;
    height: auto;
    width: -moz-fit-content !important;
    width: fit-content !important;
    background-color: #ffffff;
    color: #000000;
    text-align: center;
    border-radius: 2px;
    position: fixed;
    z-index: 1301;
    left: 0;
    right: 0;
    bottom: 36px;
    font-size: 17px;
    margin-right: 26px;
    place-self: end;
  }

  .toastCloser {
    margin-top: -6%;
    background: transparent;
    border: none;
  }

  #toast.show {
    visibility: visible;
    animation: fadein 0.5s, fadeout 0.5s 1.5s;
  }

  @keyframes fadein {
    from {
      left: 30%;
      opacity: 0;
    }

    to {
      left: 0%;
      opacity: 1;
    }
  }

  @keyframes fadeout {
    from {
      left: 0%;
      opacity: 1;
    }

    to {
      left: 30%;
      opacity: 0;
    }
  }

  .messageheadContainer {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 0%;
    padding-top: 1%;
    padding-left: 5%;
    padding-bottom: 0%;
  }

  .toast-check {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    width: 35px;
    background-color: #40f467;
    border-radius: 50%;
    color: #fff;
    font-size: 20px;
  }

  .message {
    display: flex;
    flex-direction: column;
    margin: 1px 20px 0px 7px;
    text-align: left;
    padding-left: 3%;
  }

  .message-text {
    font-size: 20px;
    font-weight: 600;
  }

  .text-1 {
    color: #333;
    margin-top: 1%;
  }

  .text-2 {
    color: #666;
    font-weight: 400;
    font-size: 16px;
    min-width: 202px;
    height: auto;
  }

  .toast-close {
    position: absolute;
    top: 10px;
    right: 15px;
    padding: 5px;
    cursor: pointer;
    opacity: 0.7;
  }

  .toast-close:hover {
    opacity: 1;
  }
}


.tree-view-container{
  .p-tree-loading-overlay{
    position: absolute;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 90vh;
  }
}

.upload-form-container{
    position: relative;
    margin-top: 10px;
  
  .upload-drop-area {
    border: 2px dashed #aaa;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    background-color: #fafafa;
    transition: background-color 0.3s ease;
  }
  
  .upload-drop-area:hover {
    background-color: #f0f8ff;
  }
  
  .upload-icon {
    font-size: 24px;
    color: #1cb5e0;
    margin-bottom: 8px;
  }
  
  .upload-label {
    display: block;
    font-weight: 500;
    color: #333;
  }
  
  .file-preview {
    margin-top: 15px;
    font-size: 14px;
    color: #444;
  }
  
  .file-preview ul {
    padding-left: 20px;
    margin: 5px 0;
  }
  
  .upload-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(250, 250, 250, 0.8);
    z-index: 10;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  
  .uploading-text {
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
  }
  
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/explorer.css"],"names":[],"mappings":"AAAA;IACI;QACI,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,oBAAoB;IACxB;IACA;MACE,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;IAClB;IACA;MACE,WAAW;EACf,YAAY;EACZ,eAAe;EACf,cAAc;IACZ;IACA,+EAA+E;;AAEnF;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,qEAAqE;AACrE;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc,aAAa,kBAAkB;EAC7C,gBAAgB,WAAW,kBAAkB;EAC7C,yBAAyB,EAAE,uCAAuC;EAClE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;IAEI;MACE,uBAAuB;IACzB;IACA;IACA,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB;IACA;MACE,WAAW;IACb;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI;YACI,gBAAgB;QACpB;;QAEA;YACI,UAAU;QACd;;IAEJ;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;;IAE9B;QACI,eAAe;QACf,uBAAuB;QACvB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;AACA;IACI,gBAAgB;EAClB,kBAAkB;;EAElB;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,kCAA6B;IAA7B,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,mBAAmB;IAEnB,yCAAyC;EAC3C;;EAcA;IACE;MACE,SAAS;MACT,UAAU;IACZ;;IAEA;MACE,QAAQ;MACR,UAAU;IACZ;EACF;;EAcA;IACE;MACE,QAAQ;MACR,UAAU;IACZ;;IAEA;MACE,SAAS;MACT,UAAU;IACZ;EACF;;EAEA;IACE,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;;AAGA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;;EAElB;IACE,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;EACb;;AAEF","sourcesContent":[".explorerContainer {\n    .controlbuttons {\n        border: none;\n        border-radius: 50%;\n        height: 30px;\n        width: 30px;\n        margin-right: 0.3rem;\n    }\n    .file-viewer{\n      overflow-x: hidden;\n      max-width: 300px;\n      overflow-y: auto;\n    }\n    .width-full-tree{\n      width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  flex: 1 1 auto;\n    }\n    /* Add this to your main CSS file (e.g., index.css or component-specific CSS) */\n\n.custom-context-menu {\n  position: absolute;\n  width: 200px;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  overflow: hidden;\n  font-size: 14px;\n  transform-origin: bottom;\n}\n\n/* Ensure the menu opens upwards if near the bottom of the viewport */\n.custom-context-menu.open-upwards {\n  transform: translateY(-100%-100);\n}\n\n.folder-path{\n  color: #2c3e50;            /* Dark but soft */\n  font-weight: 600;          /* Slightly bold */\n  background-color: #f4f6f8; /* Light gray background for contrast */\n  padding: 4px 8px;\n  border-radius: 6px;\n  display: inline-block;\n  max-width: 100%;\n  overflow-x: auto;\n  white-space: nowrap;\n}\n\n.custom-context-menu button {\n  width: 100%;\n  padding: 10px 16px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.custom-context-menu button:hover {\n  background-color: #f1f1f1;\n}\n\n.custom-context-menu .danger {\n  color: #e53935;\n}\n\n.custom-context-menu .danger:hover {\n  background-color: #fdecea;\n}\n\n    .card-body-container{\n      background-color: white;\n    }\n    .overflow-text-wrap{\n    width: 22vw;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    }\n    .controller-container{\n      width: 12vw;\n    }\n\n    .editStorageButton {\n        background: #f8f7ff;\n        color: #16a085;\n    }\n\n    .editStorageButton:hover {\n        background: #16a085;\n        color: white;\n    }\n\n    .deleteStorageButton {\n        background: #f8f7ff;\n        color: #d63031;\n    }\n\n    .deleteStorageButton:hover {\n        background: #d63031;\n        color: white;\n    }\n\n    .menubuttons {\n        width: 100%;\n        border: none;\n        text-align: left;\n    }\n\n    .menubuttons:hover {\n        background-color: rgb(230, 230, 230);\n    }\n\n    .ContainerForExplorer {\n        .MuiBackdrop-root {\n            background: none;\n        }\n\n        .MuiBox-root {\n            width: 50%;\n        }\n\n    }\n}\n\n.containerForModalSelector {\n    display: flex;\n    justify-content: space-between;\n\n    .toastCloser {\n        margin-top: -6%;\n        background: transparent;\n        border: none;\n    }\n}\n\n.add-storage-modal-container{\n    .mandatory-fields{\n        color: red;\n    }\n}\n.alert-container{\n    margin-top: 0.5%;\n  position: absolute;\n\n  .alertImg {\n    margin-left: 3%;\n  }\n\n  #toast {\n    visibility: hidden;\n    border: 1px solid;\n    border-left: 10px solid;\n    height: auto;\n    width: fit-content !important;\n    background-color: #ffffff;\n    color: #000000;\n    text-align: center;\n    border-radius: 2px;\n    position: fixed;\n    z-index: 1301;\n    left: 0;\n    right: 0;\n    bottom: 36px;\n    font-size: 17px;\n    margin-right: 26px;\n    place-self: end;\n  }\n\n  .toastCloser {\n    margin-top: -6%;\n    background: transparent;\n    border: none;\n  }\n\n  #toast.show {\n    visibility: visible;\n    -webkit-animation: fadein 0.5s, fadeout 0.5s 1s;\n    animation: fadein 0.5s, fadeout 0.5s 1.5s;\n  }\n\n  @-webkit-keyframes fadein {\n    from {\n      left: 30%;\n      opacity: 0;\n    }\n\n    to {\n      left: 0%;\n      opacity: 1;\n    }\n  }\n\n  @keyframes fadein {\n    from {\n      left: 30%;\n      opacity: 0;\n    }\n\n    to {\n      left: 0%;\n      opacity: 1;\n    }\n  }\n\n  @-webkit-keyframes fadeout {\n    from {\n      left: 0%;\n      opacity: 1;\n    }\n\n    to {\n      left: 30%;\n      opacity: 0;\n    }\n  }\n\n  @keyframes fadeout {\n    from {\n      left: 0%;\n      opacity: 1;\n    }\n\n    to {\n      left: 30%;\n      opacity: 0;\n    }\n  }\n\n  .messageheadContainer {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    padding: 0%;\n    padding-top: 1%;\n    padding-left: 5%;\n    padding-bottom: 0%;\n  }\n\n  .toast-check {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 35px;\n    width: 35px;\n    background-color: #40f467;\n    border-radius: 50%;\n    color: #fff;\n    font-size: 20px;\n  }\n\n  .message {\n    display: flex;\n    flex-direction: column;\n    margin: 1px 20px 0px 7px;\n    text-align: left;\n    padding-left: 3%;\n  }\n\n  .message-text {\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  .text-1 {\n    color: #333;\n    margin-top: 1%;\n  }\n\n  .text-2 {\n    color: #666;\n    font-weight: 400;\n    font-size: 16px;\n    min-width: 202px;\n    height: auto;\n  }\n\n  .toast-close {\n    position: absolute;\n    top: 10px;\n    right: 15px;\n    padding: 5px;\n    cursor: pointer;\n    opacity: 0.7;\n  }\n\n  .toast-close:hover {\n    opacity: 1;\n  }\n}\n\n\n.tree-view-container{\n  .p-tree-loading-overlay{\n    position: absolute;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 90vh;\n  }\n}\n\n.upload-form-container{\n    position: relative;\n    margin-top: 10px;\n  \n  .upload-drop-area {\n    border: 2px dashed #aaa;\n    padding: 20px;\n    border-radius: 8px;\n    text-align: center;\n    cursor: pointer;\n    background-color: #fafafa;\n    transition: background-color 0.3s ease;\n  }\n  \n  .upload-drop-area:hover {\n    background-color: #f0f8ff;\n  }\n  \n  .upload-icon {\n    font-size: 24px;\n    color: #1cb5e0;\n    margin-bottom: 8px;\n  }\n  \n  .upload-label {\n    display: block;\n    font-weight: 500;\n    color: #333;\n  }\n  \n  .file-preview {\n    margin-top: 15px;\n    font-size: 14px;\n    color: #444;\n  }\n  \n  .file-preview ul {\n    padding-left: 20px;\n    margin: 5px 0;\n  }\n  \n  .upload-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(250, 250, 250, 0.8);\n    z-index: 10;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .uploading-text {\n    font-weight: bold;\n    margin-bottom: 10px;\n    color: #333;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
